<obg-m-sga-login-notice [data]="data" (anchorClick)="closeDialog()"></obg-m-sga-login-notice>
